// Set environment
const env = {
    stage: "production",
    version: "1.27.15"
} 

export default env;